import React, {useState, useRef,useEffect,} from 'react';
import { useNavigate } from 'react-router-dom';
import { db } from './firebase';

import {collection,addDoc,getDocs,} from 'firebase/firestore';
import ethnicWear from './images/ethnic.jpg';
import westernWear from './images/western.jpg';
import shortKurti from './images/short.jpg';
import trialBagIcon from './images/trialbag.png';
import formalWear from './images/short.jpg';
import coordSets from './images/dress2.jpg';

const deliveryDays = [
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
  'Sunday',
];

const timeSlots = [
  '12 PM – 3 PM',
  '3 PM – 6 PM',
  '6 PM – 9 PM',
];


  export default function CustomerHome() {

  const [tryBag, setTryBag] = useState(() => {
  try {
    const saved = localStorage.getItem('fivetryBag');
    return saved ? JSON.parse(saved) : [];
  } catch (e) {
    return [];
  }
});
  const navigate = useNavigate();
  const [products, setProducts] = useState([]);
  const [selectedSizes, setSelectedSizes] = useState({});
  const [showMenu, setShowMenu] = useState(false);
  const [comingSoonItem, setComingSoonItem] = useState(null);
useEffect(() => {
  const fetchProducts = async () => {
    try {
      const querySnapshot = await getDocs(collection(db, 'products'));
      const productsData = [];
      querySnapshot.forEach((doc) => {
        productsData.push({
          id: doc.id,
          ...doc.data(),
        });
      });
      setProducts(productsData);
    } catch (error) {
      console.error('Error fetching products:', error);
    }
  };

  fetchProducts();}, []);
  useEffect(() => {
  try {
    localStorage.setItem('fivetryBag', JSON.stringify(tryBag));
  } catch (e) {}
}, [tryBag]);

useEffect(() => {
  const params = new URLSearchParams(window.location.search);
  if (params.get('openTrybag') === 'true') {
    setShowTryBag(true);
    window.history.replaceState({}, '', '/');
  }
}, []);
const [showTryBag, setShowTryBag] = useState(false);
const [showCheckout, setShowCheckout] = useState(false);
const [selectedDay, setSelectedDay] = useState(null);
const [selectedSlot, setSelectedSlot] = useState(null);
const [customerName, setCustomerName] = useState('');
const [customerPhone, setCustomerPhone] = useState('');
const [customerAddress, setCustomerAddress] = useState('');
const [showSuccess, setShowSuccess] = useState(false);
const [phone, setPhone] = useState('');
const [phoneSubmitted, setPhoneSubmitted] = useState(false);
const [discountCode, setDiscountCode] = useState('');
const [bookingId, setBookingId] = useState('');
const [selectedProduct, setSelectedProduct] = useState(null);
const [selectedCategory, setSelectedCategory] =
  useState(null);
  const [showCollections, setShowCollections] =
  useState(false);
const homeRef = useRef(null);

const collectionRef = useRef(null);

const contactRef = useRef(null);
const carouselRef = useRef(null);
useEffect(() => {
  const el = carouselRef.current;
  if (!el) return;
  const id = setInterval(() => {
    const max = el.scrollWidth - el.clientWidth;
    if (el.scrollLeft >= max - 5) el.scrollTo({ left: 0, behavior: 'smooth' });
    else el.scrollBy({ left: el.clientWidth * 0.6, behavior: 'smooth' });
  }, 3500);
  return () => clearInterval(id);
}, []);
window.onpopstate = () => {

  if (selectedProduct) {
    setSelectedProduct(null);
    return;
  }

};
  const addToTryBag = (product) => {

    if (tryBag.length >= 5) {
      alert('You can only select up to 5 items in TryBag.');
      return;
    }

    setTryBag([...tryBag, product]);
  };
  const inputStyle = {
  width: '100%',
  padding: '14px',
  marginBottom: '18px',
  borderRadius: '12px',
  border: '1px solid #ddd',
  fontSize: '16px',
  boxSizing: 'border-box',
};
  const removeFromTryBag = (indexToRemove) => {
  setTryBag(
    tryBag.filter((_, index) => index !== indexToRemove)
  );
};

  return (
    <div
  ref={homeRef}
  style={{
    minHeight: '100vh',
    fontFamily: 'Arial',
    background: 'linear-gradient(180deg, #fdf7f1 0%, #f7ede3 55%, #f2e6d6 100%)',
  }}
>

    
      {/* NAVBAR */}
<div
  style={{
    position: 'sticky',
    top: 0,
    zIndex: 1000,
    background: '#1f4d3d',
    borderBottom: '2px solid #b89968',
    width: '100%',
    boxSizing: 'border-box',
  }}
>

  {/* SEARCH BAR ROW */}
  <div style={{ display: 'flex', justifyContent: 'center', padding: '14px 14px 0' }}>
    <div style={{
      width: '100%', maxWidth: '340px', padding: '9px 18px', borderRadius: '30px',
      border: '1px solid #d6cdb8', background: '#ffffff',
      display: 'flex', alignItems: 'center', gap: '8px',
    }}>
      <input type="text" placeholder="Search styles..." style={{
        flex: 1, border: 'none', background: 'transparent', outline: 'none',
       fontSize: '13px', color: '#1a1a1a', fontFamily: 'inherit', letterSpacing: '0.3px',
      }} />
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"
        fill="none" stroke="#9c7d4f" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="11" cy="11" r="8" />
        <line x1="21" y1="21" x2="16.65" y2="16.65" />
      </svg>
    </div>
  </div>

  {/* MAIN NAV ROW */}
  <div style={{ display: 'flex', alignItems: 'center', padding: '14px 14px 12px', boxSizing: 'border-box' }}>

    {/* LEFT: Hamburger */}
    <div style={{ flex: 1, display: 'flex', justifyContent: 'flex-start' }}>
      <span onClick={() => setShowMenu(true)} style={{
        cursor: 'pointer', display: 'flex', flexDirection: 'column', gap: '5px', padding: '4px',
      }}>
        <span style={{ width: '22px', height: '1.5px', background: '#faf3ea' }}></span>
        <span style={{ width: '22px', height: '1.5px', background: '#faf3ea' }}></span>
        <span style={{ width: '22px', height: '1.5px', background: '#faf3ea' }}></span>
      </span>
    </div>

    {/* CENTER: Logo */}
    <div style={{ flex: 1, display: 'flex', justifyContent: 'center' }}>
      <h1 style={{
        margin: 0, fontSize: '22px', fontWeight: '500', color: '#faf3ea',
        fontFamily: '"Playfair Display", Georgia, serif', letterSpacing: '6px', paddingLeft: '6px',
      }}>FIVETRY</h1>
    </div>

    {/* RIGHT: TRY BAG */}
    <div style={{ flex: 1, display: 'flex', justifyContent: 'flex-end' }}>
      <span onClick={() => setShowTryBag(true)} style={{
        cursor: 'pointer', display: 'flex', alignItems: 'center', position: 'relative', gap: '6px',
      }}>
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', lineHeight: '1.15' }}>
          <span style={{ fontSize: '11px', fontWeight: '600', letterSpacing: '2px', color: '#faf3ea' }}>TRY</span>
          <span style={{ fontSize: '11px', fontWeight: '600', letterSpacing: '2px', color: '#faf3ea' }}>BAG</span>
        </div>
        <span style={{ position: 'relative', display: 'flex', alignItems: 'center' }}>
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"
            fill="none" stroke="#faf3ea" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
            <path d="M6 2 L3 6 V20 a2 2 0 0 0 2 2 H19 a2 2 0 0 0 2-2 V6 L18 2 Z" />
            <line x1="3" y1="6" x2="21" y2="6" />
            <path d="M16 10 a4 4 0 0 1 -8 0" />
          </svg>
          {tryBag.length > 0 && (
            <span style={{
              position: 'absolute', top: '-7px', right: '-9px', background: '#b89968',
              color: '#1f4d3d', borderRadius: '50%', width: '16px', height: '16px', fontSize: '9px',
              display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: '700',
            }}>{tryBag.length}</span>
          )}
        </span>
      </span>
    </div>
  </div>
</div>

      {/* HERO SECTION */}
<div
  style={{
    textAlign: 'center',
    padding: '12px 24px 4px',
    background: 'transparent',
  }}
>

  {/* Eyebrow */}
  <div
  style={{
    fontFamily: 'neto serif',
    fontSize: '14px',
    letterSpacing: '4px',
    color: '#9c7d4f',
    marginBottom: '8px',
    fontWeight: '800',
    fontStyle: 'san serif',
    textTransform: 'uppercase',
  }}
>
  Try before you buy
</div>

<div
  style={{
    width: '40px',
    height: '1px',
    background: '#9c7d4f',
    margin: '0 auto 4px',
  }}
></div>

  {/* Headline */}
  

  

</div>
{/* HOW IT WORKS SECTION */}
<div style={{
  padding: window.innerWidth < 600 ? '8px 12px 0' : '20px 40px 0',
  background: '#fafaf7',
  textAlign: 'center',
}}>
  <div style={{
    fontFamily: 'neto serif', fontSize: '12px', letterSpacing: '4px',
    color: '#9c7d4f', marginBottom: '6px', fontWeight: '600', textTransform: 'uppercase',
  }}>How it works</div>

  <h2 style={{
    fontFamily: '"Playfair Display", Georgia, serif',
    fontSize: window.innerWidth < 600 ? '19px' : '38px',
    fontWeight: '500', color: '#1a1a1a', margin: 0,
    marginBottom: window.innerWidth < 600 ? '10px' : '24px',
    letterSpacing: '-0.3px', lineHeight: '1.1', whiteSpace: 'nowrap',
  }}>Four steps to your closet</h2>

  <div style={{
    display: 'grid',
    gridTemplateColumns: 'repeat(4, 1fr)',
    gap: window.innerWidth < 600 ? '6px' : '24px',
    maxWidth: '1100px', margin: '0 auto',
  }}>
    {[
      { n: '01', t: 'Select styles', d: 'Pick 5 favourites' },
      { n: '02', t: 'Book a trial', d: 'Choose a time slot' },
      { n: '03', t: 'Try at home', d: 'Next-day, 30-min trial' },
      { n: '04', t: 'Keep or return', d: 'Pay for what you keep' },
    ].map((s) => (
      <div key={s.n} style={{
        textAlign: 'center',
        background: '#ffffff',
        border: '1px solid #eeeae3',
        borderRadius: '12px',
        padding: window.innerWidth < 600 ? '12px 5px' : '28px 16px',
        boxShadow: '0 6px 18px rgba(0,0,0,0.05)',
      }}>
        <div style={{
          fontFamily: '"Playfair Display", Georgia, serif',
          fontSize: window.innerWidth < 600 ? '24px' : '60px',
          fontWeight: '400', color: '#9c7d4f',
          marginBottom: window.innerWidth < 600 ? '3px' : '14px',
          lineHeight: '1', fontStyle: 'italic',
        }}>{s.n}</div>
        <h3 style={{
          fontFamily: '"Playfair Display", Georgia, serif',
          fontSize: window.innerWidth < 600 ? '11px' : '19px',
          fontWeight: '600', color: '#1a1a1a', margin: 0,
          marginBottom: window.innerWidth < 600 ? '2px' : '10px',
          lineHeight: '1.15',
        }}>{s.t}</h3>
        <p style={{
          fontSize: window.innerWidth < 600 ? '9px' : '13px',
          color: '#2a2a2a', lineHeight: '1.3', margin: 0,
        }}>{s.d}</p>
      </div>
    ))}
  </div>
</div>
      
{/* CATEGORY CAROUSEL */}
<div
  ref={collectionRef}
  style={{
    padding: window.innerWidth < 600 ? '4px 0 20px' : '8px 0 32px',
    background: '#fafaf7',
  }}
>
  <div style={{ textAlign: 'center', marginBottom: '14px' }}>
    <div style={{
      fontFamily: '"Playfair Display", Georgia, serif',
      fontSize: '13px', letterSpacing: '5px', color: '#9c7d4f',
      fontWeight: '600', textTransform: 'uppercase',
    }}>Shop by category</div>
  </div>

  <div
    ref={carouselRef}
    style={{
      display: 'flex',
      gap: '14px',
      overflowX: 'auto',
      scrollSnapType: 'x mandatory',
      padding: '0 18px 6px',
      scrollbarWidth: 'none',
      msOverflowStyle: 'none',
      WebkitOverflowScrolling: 'touch',
    }}
  >
    {[
      { name: 'Western Wear', image: westernWear, slug: 'western-wear' },
      { name: 'Ethnic Wear', image: ethnicWear, slug: 'ethnic-wear' },
      { name: 'Formal Wear', image: formalWear, slug: 'formal-wear' },
      { name: 'Co-ord Sets', image: coordSets, slug: 'co-ord-sets' },
    ].map((cat) => (
      <div
        key={cat.name}
       onClick={() => navigate('/shop/' + cat.slug)}
        style={{
          flex: '0 0 auto',
          width: window.innerWidth < 600 ? '150px' : '230px',
          height: window.innerWidth < 600 ? '215px' : '320px',
          scrollSnapAlign: 'center',
          cursor: 'pointer',
          position: 'relative',
          overflow: 'hidden',
          borderRadius: '16px',
          background: '#eeeae3',
          boxShadow: '0 8px 22px rgba(0,0,0,0.10)',
        }}
      >
        <img src={cat.image} alt={cat.name}
          style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
        <div style={{
          position: 'absolute', bottom: '12px', left: '50%', transform: 'translateX(-50%)',
          background: '#9c7d4f', color: 'white', padding: '7px 16px', borderRadius: '6px',
          fontSize: '11px', fontWeight: '500', whiteSpace: 'nowrap',
          fontFamily: '"Playfair Display", Georgia, serif',
          boxShadow: '0 4px 12px rgba(0,0,0,0.18)',
        }}>Shop {cat.name}</div>
      </div>
    ))}
  </div>
</div>

{/* PLUS SIZES BAND */}
<div
  style={{
    background: '#1a1a1a',
    padding: '22px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '14px',
  }}
>

  {/* Left: text content */}
  <div style={{ flex: 1, minWidth: 0 }}>
    <div
      style={{
        fontFamily:
          'neto serif',
        fontSize: '22px',
        color: '#b89968',
        marginBottom: '6px',
        fontWeight: '500',
        fontStyle: 'italic',
        letterSpacing: '0.3px',
      }}
    >
      We also do, Specially for you
    </div>

    <div
      style={{
        fontFamily:
          'neto serif',
        fontSize: '24px',
        color: '#ffffff',
        fontWeight: '500',
        marginBottom: '8px',
        letterSpacing: '0.5px',
        lineHeight: '1.1',
      }}
    >
      4xl - 5xl - 6xl
    </div>

    <div
      style={{
        fontSize: '12px',
        color: '#a8a092',
        fontStyle: 'italic',
        letterSpacing: '0.2px',
      }}
    >
      Premium styles in every size. Always.
    </div>
  </div>

  {/* Right: SHOP PLUS SIZES pill button */}
  <button
    onClick={() => {
  navigate('/plus-sizes');
}}
    style={{
      background: '#9c7d4f',
      color: 'white',
      border: 'none',
      fontSize: '13px',
      letterSpacing: '0.4px',
      fontWeight: '500',
      cursor: 'pointer',
      padding: '10px 18px',
      borderRadius: '999px',
      fontFamily:
        'neto serif',
      whiteSpace: 'nowrap',
      flexShrink: 0,
      boxShadow:
        '0 4px 12px rgba(0,0,0,0.25)',
    }}
  >
    Shop Plus Sizes
  </button>

</div>

{/* WELCOME OFFER BAND */}
<div
  style={{
    background: '#fafaf7',
    padding:
      window.innerWidth < 600
        ? '70px 24px 80px'
        : '100px 40px 110px',
    textAlign: 'center',
    borderTop: '0.5px solid #eeeae3',
  }}
>

  {/* Eyebrow */}
  <div
    style={{
      fontFamily:
        '"Playfair Display", Georgia, serif',
      fontSize: '13px',
      letterSpacing: '5px',
      color: '#9c7d4f',
      marginBottom: '14px',
      fontWeight: '600',
      textTransform: 'uppercase',
    }}
  >
    Welcome to FIVETRY
  </div>

  {/* Headline */}
  <h2
    style={{
      fontFamily:
        '"Playfair Display", Georgia, serif',
      fontSize:
        window.innerWidth < 600
          ? '34px'
          : '46px',
      fontWeight: '500',
      color: '#1a1a1a',
      margin: 0,
      marginBottom: '20px',
      lineHeight: '1.15',
      letterSpacing: '-0.5px',
    }}
  >
    <span style={{ color: '#9c7d4f' }}>20% off</span> your first trial onwards.
  </h2>

  {/* Subtitle */}
  <p
    style={{
      fontFamily:
        '"Playfair Display", Georgia, serif',
      fontSize: '16px',
      color: '#2a2a2a',
      fontStyle: 'italic',
      lineHeight: '1.6',
      maxWidth: '420px',
      margin: '0 auto 32px',
      fontWeight: '400',
    }}
  >
    Drop your WhatsApp number. We'll send your code straight to you.
  </p>

  {/* Phone form OR success message */}
  {!phoneSubmitted ? (
    <div
      style={{
        display: 'flex',
        gap: '10px',
        maxWidth: '420px',
        margin: '0 auto',
        flexDirection:
          window.innerWidth < 500
            ? 'column'
            : 'row',
      }}
    >
      <input
        type="tel"
        value={phone}
        onChange={(e) =>
          setPhone(e.target.value)
        }
        placeholder="Your WhatsApp number"
        style={{
          flex: 1,
          padding: '14px 18px',
          fontSize: '14px',
          border: '1px solid #d6cdb8',
          borderRadius: '4px',
          outline: 'none',
          background: 'transparent',
          fontFamily: 'inherit',
          color: '#1a1a1a',
          boxSizing: 'border-box',
        }}
      />
      <button
        onClick={async () => {
  const cleanPhone = phone.replace(/\D/g, '');
  if (cleanPhone.length < 10) {
    alert(
      'Please enter a valid 10-digit WhatsApp number.'
    );
    return;
  }
  try {
    // Count existing leads to generate sequential code
    const leadsSnapshot = await getDocs(
      collection(db, 'leads')
    );
    const newCustomerNumber =
      1001 + leadsSnapshot.size;
    const code = `FT20${newCustomerNumber}`;

    await addDoc(
      collection(db, 'leads'),
      {
        whatsapp: cleanPhone,
        code,
        offer: '20_off_first_trial',
        createdAt: new Date(),
      }
    );

    setDiscountCode(code);
    setPhoneSubmitted(true);
  } catch (error) {
    console.error(
      'Error saving number:',
      error
    );
    alert(
      'Something went wrong. Please try again.'
    );
  }
}
        }
        style={{
          background: '#1a1a1a',
          color: '#ffffff',
          border: 'none',
          padding: '14px 28px',
          fontSize: '12px',
          letterSpacing: '2px',
          fontWeight: '500',
          borderRadius: '4px',
          cursor: 'pointer',
          fontFamily: 'inherit',
          whiteSpace: 'nowrap',
        }}
      >
        CLAIM OFFER
      </button>
    </div>
  ) : (
    <div
  style={{
    background: '#eeeae3',
    padding: '28px 24px',
    borderRadius: '8px',
    maxWidth: '420px',
    margin: '0 auto',
    textAlign: 'center',
  }}
>
  <p
    style={{
      fontFamily:
        '"Playfair Display", Georgia, serif',
      fontSize: '20px',
      color: '#1a1a1a',
      fontWeight: '500',
      margin: 0,
      marginBottom: '14px',
    }}
  >
    ✓ You're in.
  </p>

  <p
    style={{
      fontSize: '18px',
      color: '#2a2a2a',
      margin: 0,
      marginBottom: '10px',
      letterSpacing: '1px',
      textTransform: 'uppercase',
      fontWeight: '600',
    }}
  >
    Your 20% off code
  </p>

  <div
    style={{
      background: '#fafaf7',
      border: '2px dashed #9c7d4f',
      borderRadius: '8px',
      padding: '14px 20px',
      margin: '0 auto 14px',
      maxWidth: '260px',
      fontFamily:
        'neto serif',
      fontSize: '24px',
      color: '#1a1a1a',
      letterSpacing: '3px',
      fontWeight: '600',
    }}
  >
    {discountCode}
  </div>

  <p
    style={{
      fontSize: '18px',
      color: '#666',
      margin: 0,
      lineHeight: '1.5',
      fontStyle: 'italic',
    }}
  >
    We will apply the code automatically as per the policy.
  </p>
</div>
  )}

</div>
      {/* PRODUCT SECTION */}
     {selectedCategory && ( 
      <div
        style={{
          padding:
  window.innerWidth < 600
    ? '20px'
    : '40px',
        }}
      >
        <h2
          style={{
            textAlign: 'center',
            marginBottom: '40px',
            fontSize: '38px',
            color: '#111',
          }}
        >
          Trending Styles 
        </h2>

        <div
  ref={collectionRef}
  style={{
    display: 'grid',
            gridTemplateColumns:
              'repeat(auto-fit, minmax(260px, 1fr))',
            gap: '30px',
          }}
        >
          {products
  .filter((product) =>

    selectedCategory
      ? product.category ===
        selectedCategory
      : true

  )
  .map((product) => ( 
            <div
              key={product.id}
              style={{
            
                background: 'white',
                borderRadius: '24px',
                overflow: 'hidden',
                boxShadow:
                  '0 18px 45px rgba(0,0,0,0.14)',
                transition: '0.35s ease',
cursor: 'pointer',
transform: 'translateY(0)',
              }}
              onMouseEnter={(e) => {
  e.currentTarget.style.transform = 'translateY(-10px)';
  e.currentTarget.style.boxShadow =
    '0 25px 60px rgba(0,0,0,0.18)';
}}
onMouseLeave={(e) => {
  e.currentTarget.style.transform = 'translateY(0)';
  e.currentTarget.style.boxShadow =
    '0 18px 45px rgba(0,0,0,0.14)';
}}
            >
              <img
  onClick={() => {

  window.history.pushState(
    {},
    ''
  );

  setSelectedProduct(product);

}}
  src={product.image}
                alt={product.name}
                style={{
                  width: '100%',
                  height:
  window.innerWidth < 600
    ? '320px'
    : '460px',
                  objectFit: 'cover',
                  cursor: 'pointer',
                }}
              />

              <div
                style={{
                  padding: '24px',
                  transition: '0.4s ease',
                }}
              >
                <h3
                  style={{
                    margin: 0,
                    marginBottom: '10px',
                    color: '#111',
                  }}
                >
                  {product.name}
                </h3>

                <div
  style={{
    display: 'flex',
    alignItems: 'baseline',
    gap: '10px',
    marginBottom: '20px',
    flexWrap: 'wrap',
  }}
>
  <span style={{ color: '#111', fontSize: '18px', fontWeight: '700' }}>
    {product.price}
  </span>
  {product.mrp && (() => {
    const priceNum = parseFloat(String(product.price).replace(/[₹,]/g, ''));
    const mrpNum = parseFloat(String(product.mrp).replace(/[₹,]/g, ''));
    if (mrpNum > priceNum) {
      const discount = Math.round(((mrpNum - priceNum) / mrpNum) * 100);
      return (
        <>
          <span style={{
            textDecoration: 'line-through',
            color: '#999',
            fontSize: '15px',
            fontWeight: '400',
          }}>{product.mrp}</span>
          <span style={{
            color: '#16a34a',
            fontSize: '14px',
            fontWeight: '700',
          }}>{discount}% OFF</span>
        </>
      );
    }
    return null;
  })()}
</div>

                {Array.isArray(product.sizes) && product.sizes.length > 0 && (
                  <div style={{ marginBottom: '14px' }}>
                    <div style={{
                      fontSize: '11px',
                      color: '#666',
                      letterSpacing: '1px',
                      marginBottom: '8px',
                      fontWeight: '600',
                      textTransform: 'uppercase',
                    }}>
                      Select Size
                    </div>
                    <div style={{
                      display: 'flex',
                      gap: '8px',
                      flexWrap: 'wrap',
                    }}>
                      {product.sizes.map((size) => {
                        const isSelected = selectedSizes[product.id] === size;
                        const soldOut = product.stock && Object.keys(product.stock).length > 0 && (parseInt(product.stock[size], 10) || 0) <= 0;
                        return (
                          <button
                            key={size}
                            disabled={soldOut}
                            onClick={() => { if (soldOut) return; setSelectedSizes({ ...selectedSizes, [product.id]: size }); }}
                            style={{
                              minWidth: '48px',
                              padding: '8px 12px',
                              background: soldOut ? '#f3f0ea' : (isSelected ? '#1a1a1a' : 'white'),
                              color: soldOut ? '#bbb' : (isSelected ? 'white' : '#1a1a1a'),
                              border: '1px solid ' + (soldOut ? '#e5e0d5' : (isSelected ? '#1a1a1a' : '#d6cdb8')),
                              borderRadius: '6px',
                              fontSize: '13px',
                              fontWeight: '600',
                              cursor: soldOut ? 'not-allowed' : 'pointer',
                              letterSpacing: '0.5px',
                              textDecoration: soldOut ? 'line-through' : 'none',
                            }}
                          >
                            {size}
                          </button>
                        );
                      })}
                    </div>
                  </div>
                )}
                {product.sizeChart && Object.keys(product.sizeChart).filter(s => product.sizeChart[s]).length > 0 && (
                  <div style={{
                    background: '#fafaf7',
                    border: '1px solid #eeeae3',
                    borderRadius: '8px',
                    padding: '12px 14px',
                    marginBottom: '14px',
                  }}>
                    <div style={{
                      fontSize: '10px',
                      letterSpacing: '1px',
                      color: '#9c7d4f',
                      fontWeight: '700',
                      textTransform: 'uppercase',
                      marginBottom: '8px',
                    }}>
                      Size Chart (chest in inches)
                    </div>
                    <div style={{ display: 'flex', gap: '4px' }}>
                      {['XS', 'S', 'M', 'L', 'XL', '2XL', '3XL', '4XL', '5XL']
                        .filter(size => product.sizeChart[size])
                        .map((size) => {
                          const isSelected = selectedSizes[product.id] === size;
                          return (
                            <div key={size} style={{
                              flex: 1,
                              textAlign: 'center',
                              padding: '6px 4px',
                              background: isSelected ? '#9c7d4f' : 'transparent',
                              borderRadius: '4px',
                              transition: '0.2s',
                            }}>
                              <div style={{
                                fontSize: '11px',
                                fontWeight: '700',
                                color: isSelected ? 'white' : '#111',
                              }}>{size}</div>
                              <div style={{
                                fontSize: '12px',
                                color: isSelected ? 'white' : '#666',
                                fontWeight: '500',
                                marginTop: '2px',
                              }}>{product.sizeChart[size]}"</div>
                            </div>
                          );
                        })}
                    </div>
                  </div>
                )}
                <button
                  onClick={() => {
                    const selectedSize = selectedSizes[product.id];
                    if (!selectedSize) {
                      alert('Please select a size first.');
                      return;
                    }
                    addToTryBag({ ...product, selectedSize });
                  }}
                  style={{
                    width: '100%',
                    background: '#111',
                    color: 'white',
                    border: 'none',
                    padding: '14px',
                    borderRadius: '10px',
                    fontSize: '16px',
                    cursor: 'pointer',
                  }}
                >
                  Try at Home
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
      )}
{/* TRYBAG PANEL */}

{showTryBag && (
  <div
    style={{
      position: 'fixed',
      top: 0,
      right: 0,
      width: window.innerWidth < 600
  ? '100%'
  : '380px',
      height: '100dvh',
      background: 'white',
      boxShadow: '-8px 0 30px rgba(0,0,0,0.15)',
      padding: '25px',
      zIndex: 2000,
      display: 'flex',
      flexDirection: 'column',
      boxSizing: 'border-box',
    }}
  >

    <div
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'baseline',
        marginBottom: '25px',
      }}
    >
      <h2>My TryBag</h2>

      <button
        onClick={() => setShowTryBag(false)}
        style={{
          border: 'none',
          background: 'transparent',
          fontSize: '24px',
          cursor: 'pointer',
        }}
      >
        ×
      </button>
    </div>

    <div style={{ flex: 1, overflowY: 'auto', minHeight: 0 }}>
    {tryBag.length === 0 ? (
      <p>Your TryBag is empty.</p>
    ) : (
      tryBag.map((item, index) => (
        <div
          key={index}
          style={{
            display: 'flex',
            gap: '15px',
            marginBottom: '20px',
            borderBottom: '1px solid #eee',
            paddingBottom: '15px',
          }}
        >
          <img
            src={item.image}
            alt={item.name}
            style={{
              width: '80px',
              height: '100px',
              objectFit: 'cover',
              borderRadius: '10px',
            }}
          />

          <div
  style={{
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    paddingTop: '4px',
  }}
>
  <h4
    style={{
      margin: 0,
      marginBottom: '10px',
      fontSize: '20px',
      color: '#111',
      lineHeight: '1.3',
    }}
  >
    {item.name}
  </h4>

  <p
    style={{
      color: '#666',
      fontSize: '18px',
      margin: 0,
      marginBottom: '6px',
    }}
  >
    {item.price}
  </p>
  {item.selectedSize && (
    <p style={{
      color: '#888',
      fontSize: '13px',
      margin: 0,
      marginBottom: '14px',
      fontWeight: '500',
      letterSpacing: '0.5px',
    }}>
      Size: <span style={{ color: '#1a1a1a', fontWeight: '700' }}>{item.selectedSize}</span>
    </p>
  )}

  <button
    onClick={() => removeFromTryBag(index)}
    style={{
      background: '#111',
      color: 'white',
      border: 'none',
      padding: '10px 18px',
      borderRadius: '10px',
      cursor: 'pointer',
      width: 'fit-content',
      fontSize: '15px',
      fontWeight: '600',
    }}
  >
    Remove
  </button>
</div>
        </div>
      ))
    )}
  
   </div>

   {/* TRYBAG SUMMARY */}

<div
  style={{
    marginTop: '20px',
    paddingTop: '20px',
    borderTop: '2px solid #eee',
    flexShrink: 0,
  }}
>

  <h3
    style={{
      marginBottom: '12px',
      color: '#111',
    }}
  >
    Items Selected: {tryBag.length} / 5
  </h3>

  <p
    style={{
      color: '#666',
      marginBottom: '25px',
      fontSize: '16px',
    }}
  >
    Remaining Slots: {5 - tryBag.length}
  </p>

  <div style={{
    background: '#fff8ec',
    border: '1px solid #f5d99a',
    borderRadius: '10px',
    padding: '10px 14px',
    marginBottom: '18px',
    textAlign: 'center',
    fontSize: '12px',
    fontWeight: '700',
    color: '#9c7d4f',
    letterSpacing: '0.3px',
  }}>
    🎁 Keep any 3+ items and save up to 20% off!
  </div>

  <button
  onClick={() => setShowCheckout(true)}
  style={{
      width: '100%',
      background: '#111',
      color: 'white',
      border: 'none',
      padding: '16px',
      borderRadius: '14px',
      fontSize: '17px',
      fontWeight: '600',
      cursor: 'pointer',
      transition: '0.3s ease',
    }}
  >
    Proceed to Checkout
  </button>

</div>

</div>

)}
{/* CHECKOUT POPUP */}

{showCheckout && (
  <div
    style={{
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100%',
      height: '100vh',
      background: 'rgba(0,0,0,0.5)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 3000,
    }}
  >

    <div
  style={{
    width: '90%',
    maxWidth: '500px',
    background: 'white',
    borderRadius: '24px',
    padding: '35px',

    maxHeight: '90vh',
    overflowY: 'auto',
  }}
>

      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginBottom: '25px',
        }}
      >
        <h2>Checkout Details</h2>

        <button
          onClick={() => setShowCheckout(false)}
          style={{
            border: 'none',
            background: 'transparent',
            fontSize: '24px',
            cursor: 'pointer',
          }}
        >
          ×
        </button>
      </div>

      <input
  placeholder="Full Name"
  value={customerName}
  onChange={(e) =>
    setCustomerName(e.target.value)
  }
  style={inputStyle}
/>
<p
  style={{
    fontSize: '14px',
    fontWeight: '700',
    color: '#111',
    marginBottom: '10px',
  }}
>
  Please use a WhatsApp-linked mobile number for booking confirmation.
</p>
      <input
  placeholder="Mobile Number"
  value={customerPhone}
  onChange={(e) =>
    setCustomerPhone(e.target.value)
  }
  style={inputStyle}
/>

      <textarea
  placeholder="Address"
  value={customerAddress}
  onChange={(e) =>
    setCustomerAddress(e.target.value)
  }
        style={{
          ...inputStyle,
          height: '100px',
        }}
      />

      <label
  style={{
    fontWeight: '600',
    display: 'block',
    marginBottom: '14px',
  }}
>
  Select Delivery Day
</label>

<div
  style={{
    display: 'flex',
    justifyContent: 'space-between',
    gap: '8px',
    marginBottom: '22px',
  }}
>
  {deliveryDays.map(
    (day, index) => {

      const now = new Date();
      const tomorrow = new Date(now);
      tomorrow.setDate(now.getDate() + 1);

      const tomorrowDay = tomorrow.getDay();
      const tomorrowAdjusted = tomorrowDay === 0 ? 6 : tomorrowDay - 1;

      const startOfWeek = new Date(tomorrow);
      startOfWeek.setDate(tomorrow.getDate() - tomorrowAdjusted);

      const currentDate = new Date(startOfWeek);
      currentDate.setDate(startOfWeek.getDate() + index);

      // Only tomorrow is selectable; every other day is blocked
      const isPastOrToday = currentDate.toDateString() !== tomorrow.toDateString();

      return (
  <div
    key={index}
    onClick={() => {
      if (!isPastOrToday) {
        setSelectedDay(index);
      }
    }}
        style={{
            width: '52px',
            height: '78px',
            borderRadius: '16px',
            background:
  selectedDay === index
    ? '#16a34a'
    : '#111',
            color: 'white',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: '10px 0',
            position: 'relative',
            cursor: isPastOrToday
              ? 'not-allowed'
              : 'pointer',
              transform:
  selectedDay === index
    ? 'translateY(-4px)'
    : 'translateY(0)',
            opacity: isPastOrToday ? 0.7 : 1,
          }}
        >

          {/* DAY LETTER */}

          <div
            style={{
              position: 'relative',
              fontWeight: '700',
              fontSize: '18px',
            }}
          >
            {day.charAt(0)}

            {isPastOrToday && (
              <span
                style={{
                  position: 'absolute',
                  top: '-4px',
                  left: '-2px',
                  fontSize: '24px',
                  color: '#ff4d4d',
                  fontWeight: '700',
                }}
              >
                ✕
              </span>
            )}
          </div>

          {/* DATE */}

          <div
            style={{
              fontSize: '17px',
              fontWeight: '600',
            }}
          >
            {currentDate.getDate()}
          </div>

        </div>
      );
    }
  )}
</div>
<p
  style={{
    color: '#666',
    fontSize: '14px',
    fontWeight: '700',
    marginBottom: '22px',
  }}
>
  Next-day delivery only. We bring tomorrow's pick to your door.
</p>

<label
  style={{
    fontWeight: '700',
    display: 'block',
    marginBottom: '14px',
    marginTop: '25px',
  }}
>
  Select Time Slot
</label>

<div
  style={{
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
    marginBottom: '24px',
  }}
>
  {timeSlots.map((slot, index) => (

    <div
      key={index}
      onClick={() => setSelectedSlot(index)}
      style={{
        background:
          selectedSlot === index
            ? '#16a34a'
            : '#111',

        color: 'white',
        padding: '16px',
        borderRadius: '14px',
        textAlign: 'center',
        fontWeight: '600',
        fontSize: '16px',
        cursor: 'pointer',
        transition: '0.3s ease',

        transform:
          selectedSlot === index
            ? 'translateY(-3px)'
            : 'translateY(0)',
      }}
    >
      {slot}
    </div>

  ))}
</div>

      <button
  onClick={async () => {

    if (
      !customerName ||
      !customerPhone ||
      !customerAddress
    ) {
      alert(
        'Please fill all customer details.'
      );
      return;
    }

    if (selectedDay === null) {
      alert(
        'Please select a delivery day.'
      );
      return;
    }

    if (selectedSlot === null) {
      alert(
        'Please select a time slot.'
      );
      return;
    }
    const generatedBookingId =
  `FT${Date.now()
    .toString()
    .slice(-5)}`;

setBookingId(
  generatedBookingId
);
await addDoc(
  collection(db, 'bookings'),
  {
  
    bookingId:
  generatedBookingId,
    customerName,
    customerPhone,
    customerAddress,

    deliveryDay: `${deliveryDays[selectedDay]} - ${(() => {
      const tomorrow = new Date();
      tomorrow.setDate(tomorrow.getDate() + 1);
      return tomorrow.toLocaleDateString('en-IN', {
        day: 'numeric',
        month: 'short',
        year: 'numeric',
      });
    })()}`,

    timeSlot:
      timeSlots[selectedSlot],

    itemsSelected:
      tryBag.length,

    selectedItems:
  tryBag.map(
    (item) => ({
      name: item.name,
      image: item.image,
      price: item.price,
      size: item.selectedSize || 'Not specified',
    })
  ),

    createdAt:
      new Date(),
      orderStatus: 'booked',
  }
);
  // Save active booking for bottom nav green state + future MyOrders lookup
    localStorage.setItem('fivetryActiveBooking', generatedBookingId);
    localStorage.setItem('fivetryCustomerPhone', customerPhone);
    // Save full booking data so MY TRIAL BAG can render items
    const activeBookingData = {
      bookingId: generatedBookingId,
      customerName,
      customerPhone,
      customerAddress,
      deliveryDay: `${deliveryDays[selectedDay]} - ${(() => {
        const tomorrow = new Date();
        tomorrow.setDate(tomorrow.getDate() + 1);
        return tomorrow.toLocaleDateString('en-IN', { day: 'numeric', month: 'short', year: 'numeric' });
      })()}`,
      timeSlot: timeSlots[selectedSlot],
      itemsSelected: tryBag.length,
      selectedItems: tryBag.map((item) => ({
        name: item.name,
        image: item.image,
        price: item.price,
        size: item.selectedSize || 'Not specified',
      })),
    };
    // Compute exact trial start datetime for time-lock feature
    const tomorrowAtSlot = new Date();
    tomorrowAtSlot.setDate(tomorrowAtSlot.getDate() + 1);
    const slotMatch = timeSlots[selectedSlot].match(/^(\d+)\s*(AM|PM)/i);
    let slotStartHour = 12;
    if (slotMatch) {
      slotStartHour = parseInt(slotMatch[1], 10);
      const period = slotMatch[2].toUpperCase();
      if (period === 'PM' && slotStartHour !== 12) slotStartHour += 12;
      if (period === 'AM' && slotStartHour === 12) slotStartHour = 0;
    }
    tomorrowAtSlot.setHours(slotStartHour, 0, 0, 0);
    activeBookingData.trialStartISO = tomorrowAtSlot.toISOString();
    localStorage.setItem('fivetryActiveBookingData', JSON.stringify(activeBookingData));
    localStorage.removeItem('fivetryTrialDecisions'); // Fresh start for new booking
    window.dispatchEvent(new Event('fivetryBookingChange'));

setShowSuccess(true);
  }}
  style={{
          width: '100%',
          background: '#111',
          color: 'white',
          border: 'none',
          padding: '16px',
          borderRadius: '14px',
          fontSize: '17px',
          fontWeight: '600',
          cursor: 'pointer',
          marginTop: '15px',
        }}
      >
        Confirm Trial Booking
      </button>

    </div>
  </div>
)}
{/* SUCCESS POPUP */}

{showSuccess && (
  <div
    style={{
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100%',
      height: '100vh',
      background: 'rgba(0,0,0,0.55)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 5000,
      padding: '20px',
      boxSizing: 'border-box',
    }}
  >
    <div
      style={{
        width: '100%',
        maxWidth: '460px',
        background: 'white',
        borderRadius: '26px',
        padding: '36px 28px',
        textAlign: 'center',
        boxShadow: '0 20px 60px rgba(0,0,0,0.18)',
        maxHeight: '92vh',
        overflowY: 'auto',
      }}
    >

      {/* Gold checkmark circle */}
      <div style={{
        width: '64px',
        height: '64px',
        borderRadius: '50%',
        background: '#9c7d4f',
        color: 'white',
        fontSize: '32px',
        fontWeight: '700',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        margin: '0 auto 20px',
      }}>✓</div>

      {/* Personal greeting */}
      <h2 style={{
        fontFamily: '"Playfair Display", Georgia, serif',
        fontSize: '28px',
        fontWeight: '500',
        color: '#1a1a1a',
        margin: 0,
        marginBottom: '10px',
        letterSpacing: '-0.3px',
      }}>
        You're all set{customerName ? `, ${customerName.split(' ')[0]}` : ''}!
      </h2>

      <p style={{
        fontSize: '15px',
        color: '#666',
        margin: 0,
        marginBottom: '24px',
        lineHeight: '1.5',
      }}>
        Your trial is confirmed. We're picking your styles now.
      </p>

      {/* Booking ID */}
      <div style={{
        display: 'inline-block',
        background: '#fafaf7',
        border: '1px dashed #9c7d4f',
        padding: '10px 18px',
        borderRadius: '10px',
        marginBottom: '24px',
      }}>
        <div style={{
          fontSize: '10px',
          color: '#9c7d4f',
          letterSpacing: '2px',
          fontWeight: '700',
          marginBottom: '2px',
        }}>BOOKING ID</div>
        <div style={{
          fontFamily: '"Playfair Display", Georgia, serif',
          fontSize: '20px',
          color: '#1a1a1a',
          fontWeight: '600',
          letterSpacing: '1.5px',
        }}>{bookingId}</div>
      </div>

      {/* Delivery details — dark band */}
      <div style={{
        background: '#1a1a1a',
        color: 'white',
        borderRadius: '16px',
        padding: '20px',
        marginBottom: '24px',
        textAlign: 'left',
      }}>
        <div style={{
          fontSize: '10px',
          color: '#b89968',
          letterSpacing: '2px',
          fontWeight: '700',
          marginBottom: '12px',
        }}>YOUR DELIVERY</div>

        <div style={{ marginBottom: '8px' }}>
          <span style={{ fontSize: '13px', color: '#a8a092' }}>When · </span>
          <span style={{ fontSize: '14px', color: 'white', fontWeight: '600' }}>
            Tomorrow, {(() => {
              const tomorrow = new Date();
              tomorrow.setDate(tomorrow.getDate() + 1);
              return tomorrow.toLocaleDateString('en-IN', {
                weekday: 'long',
                day: 'numeric',
                month: 'short',
              });
            })()}
          </span>
        </div>

        <div style={{ marginBottom: '8px' }}>
          <span style={{ fontSize: '13px', color: '#a8a092' }}>Slot · </span>
          <span style={{ fontSize: '14px', color: 'white', fontWeight: '600' }}>
            {timeSlots[selectedSlot]}
          </span>
        </div>

        <div>
          <span style={{ fontSize: '13px', color: '#a8a092' }}>Items · </span>
          <span style={{ fontSize: '14px', color: 'white', fontWeight: '600' }}>
            {tryBag.length} styles in your trial bag
          </span>
        </div>
      </div>

      {/* What to expect — 3 numbered steps */}
      <div style={{
        background: '#fafaf7',
        border: '1px solid #eeeae3',
        borderRadius: '14px',
        padding: '22px 20px',
        marginBottom: '24px',
        textAlign: 'left',
      }}>
        <div style={{
          fontSize: '10px',
          color: '#9c7d4f',
          letterSpacing: '2px',
          fontWeight: '700',
          marginBottom: '18px',
          textAlign: 'center',
        }}>WHAT TO EXPECT</div>

        <div style={{ display: 'flex', gap: '14px', marginBottom: '18px' }}>
          <div style={{
            fontFamily: '"Playfair Display", Georgia, serif',
            fontSize: '24px',
            color: '#9c7d4f',
            fontStyle: 'italic',
            fontWeight: '500',
            minWidth: '32px',
            lineHeight: '1',
          }}>01</div>
          <div>
            <div style={{ fontWeight: '600', fontSize: '14px', color: '#1a1a1a', marginBottom: '4px' }}>
              Confirmation call
            </div>
            <div style={{ fontSize: '13px', color: '#666', lineHeight: '1.5' }}>
              We'll call you 1 hour before delivery to make sure you're available to receive your trial.
            </div>
          </div>
        </div>

        <div style={{ display: 'flex', gap: '14px', marginBottom: '18px' }}>
          <div style={{
            fontFamily: '"Playfair Display", Georgia, serif',
            fontSize: '24px',
            color: '#9c7d4f',
            fontStyle: 'italic',
            fontWeight: '500',
            minWidth: '32px',
            lineHeight: '1',
          }}>02</div>
          <div>
            <div style={{ fontWeight: '600', fontSize: '14px', color: '#1a1a1a', marginBottom: '4px' }}>
              30-minute home trial
            </div>
            <div style={{ fontSize: '13px', color: '#666', lineHeight: '1.5' }}>
              Try every piece on in the comfort of your home. No pressure.
            </div>
          </div>
        </div>

        <div style={{ display: 'flex', gap: '14px' }}>
          <div style={{
            fontFamily: '"Playfair Display", Georgia, serif',
            fontSize: '24px',
            color: '#9c7d4f',
            fontStyle: 'italic',
            fontWeight: '500',
            minWidth: '32px',
            lineHeight: '1',
          }}>03</div>
          <div>
            <div style={{ fontWeight: '600', fontSize: '14px', color: '#1a1a1a', marginBottom: '4px' }}>
              Keep what you love
            </div>
            <div style={{ fontSize: '13px', color: '#666', lineHeight: '1.5' }}>
              Pay only for what you decide to keep. Return the rest, free.
            </div>
          </div>
        </div>
      </div>

      {/* Done button */}
      <button
        onClick={() => {
          setShowSuccess(false);
          setShowCheckout(false);
          setShowTryBag(false);
          setTryBag([]);
          setSelectedDay(null);
          setSelectedSlot(null);
          setCustomerName('');
          setCustomerPhone('');
          setCustomerAddress('');
        }}
        style={{
          width: '100%',
          background: '#1a1a1a',
          color: 'white',
          border: 'none',
          padding: '16px',
          borderRadius: '14px',
          fontSize: '15px',
          fontWeight: '600',
          cursor: 'pointer',
          marginBottom: '16px',
          letterSpacing: '0.5px',
        }}
      >
        Done
      </button>

      {/* Help footer */}
      <div style={{
        fontSize: '12px',
        color: '#888',
        lineHeight: '1.5',
      }}>
        
        Need help? WhatsApp us at{' '}
        <a
          href="https://wa.me/918108885858"
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: '#9c7d4f', fontWeight: '600', textDecoration: 'none' }}
        >
          +91 8108885858
        </a>
      </div>

    </div>
  </div>
)}

{/* PRODUCT QUICK VIEW */}

{selectedProduct && (
  <div
    onClick={() =>
      setSelectedProduct(null)
    }
    style={{
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100%',
      height: '100vh',
      background: 'rgba(0,0,0,0.75)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 4000,
      padding: '20px',
      boxSizing: 'border-box',
    }}
  >

    <div
      onClick={(e) => e.stopPropagation()}
      style={{
        width: '100%',
        maxWidth: '450px',
        background: 'white',
        borderRadius: '24px',
        overflow: 'hidden',
        boxShadow:
          '0 25px 70px rgba(0,0,0,0.25)',
      }}
    >

      <img
        src={selectedProduct.image}
        alt={selectedProduct.name}
        style={{
          width: '100%',
          height:
            window.innerWidth < 600
              ? '420px'
              : '520px',
          objectFit: 'cover',
        }}
      />

      <div
        style={{
          padding: '24px',
        }}
      >

        <h2
          style={{
            marginBottom: '10px',
            color: '#111',
          }}
        >
          {selectedProduct.name}
        </h2>

        <div
  style={{
    display: 'flex',
    alignItems: 'baseline',
    gap: '10px',
    marginBottom: '22px',
    flexWrap: 'wrap',
  }}
>
  <span style={{ color: '#111', fontSize: '20px', fontWeight: '700' }}>
    {selectedProduct.price}
  </span>
  {selectedProduct.mrp && (() => {
    const priceNum = parseFloat(String(selectedProduct.price).replace(/[₹,]/g, ''));
    const mrpNum = parseFloat(String(selectedProduct.mrp).replace(/[₹,]/g, ''));
    if (mrpNum > priceNum) {
      const discount = Math.round(((mrpNum - priceNum) / mrpNum) * 100);
      return (
        <>
          <span style={{
            textDecoration: 'line-through',
            color: '#999',
            fontSize: '16px',
            fontWeight: '400',
          }}>{selectedProduct.mrp}</span>
          <span style={{
            color: '#16a34a',
            fontSize: '15px',
            fontWeight: '700',
          }}>{discount}% OFF</span>
        </>
      );
    }
    return null;
  })()}
</div>

        {Array.isArray(selectedProduct.sizes) && selectedProduct.sizes.length > 0 && (
          <div style={{ marginBottom: '18px' }}>
            <div style={{
              fontSize: '11px',
              color: '#666',
              letterSpacing: '1px',
              marginBottom: '10px',
              fontWeight: '600',
              textTransform: 'uppercase',
            }}>
              Select Size
            </div>
            <div style={{
              display: 'flex',
              gap: '8px',
              flexWrap: 'wrap',
            }}>
              {selectedProduct.sizes.map((size) => {
                const isSelected = selectedSizes[selectedProduct.id] === size;
                return (
                  <button
                    key={size}
                    onClick={() => setSelectedSizes({ ...selectedSizes, [selectedProduct.id]: size })}
                    style={{
                      minWidth: '48px',
                      padding: '10px 14px',
                      background: isSelected ? '#1a1a1a' : 'white',
                      color: isSelected ? 'white' : '#1a1a1a',
                      border: '1px solid ' + (isSelected ? '#1a1a1a' : '#d6cdb8'),
                      borderRadius: '6px',
                      fontSize: '14px',
                      fontWeight: '600',
                      cursor: 'pointer',
                      letterSpacing: '0.5px',
                    }}
                  >
                    {size}
                  </button>
                );
              })}
            </div>
          </div>
        )}
        {selectedProduct.sizeChart && Object.keys(selectedProduct.sizeChart).filter(s => selectedProduct.sizeChart[s]).length > 0 && (
          <div style={{
            background: '#fafaf7',
            border: '1px solid #eeeae3',
            borderRadius: '8px',
            padding: '14px 16px',
            marginBottom: '18px',
          }}>
            <div style={{
              fontSize: '10px',
              letterSpacing: '1px',
              color: '#9c7d4f',
              fontWeight: '700',
              textTransform: 'uppercase',
              marginBottom: '10px',
            }}>
              Size Chart (chest in inches)
            </div>
            <div style={{ display: 'flex', gap: '4px' }}>
              {['XS', 'S', 'M', 'L', 'XL', '2XL', '3XL', '4XL', '5XL']
                .filter(size => selectedProduct.sizeChart[size])
                .map((size) => {
                  const isSelected = selectedSizes[selectedProduct.id] === size;
                  return (
                    <div key={size} style={{
                      flex: 1,
                      textAlign: 'center',
                      padding: '8px 4px',
                      background: isSelected ? '#9c7d4f' : 'transparent',
                      borderRadius: '4px',
                      transition: '0.2s',
                    }}>
                      <div style={{
                        fontSize: '12px',
                        fontWeight: '700',
                        color: isSelected ? 'white' : '#111',
                      }}>{size}</div>
                      <div style={{
                        fontSize: '13px',
                        color: isSelected ? 'white' : '#666',
                        fontWeight: '500',
                        marginTop: '3px',
                      }}>{selectedProduct.sizeChart[size]}"</div>
                    </div>
                  );
                })}
            </div>
          </div>
        )}
        <button
          onClick={() => {
            const selectedSize = selectedSizes[selectedProduct.id];
            if (!selectedSize) {
              alert('Please select a size first.');
              return;
            }
            addToTryBag({ ...selectedProduct, selectedSize });
            setSelectedProduct(null);
          }}
          style={{
            width: '100%',
            background: '#111',
            color: 'white',
            border: 'none',
            padding: '16px',
            borderRadius: '14px',
            fontSize: '16px',
            fontWeight: '600',
            cursor: 'pointer',
          }}
        >
          Try at Home
        </button>

      </div>
    </div>
  </div>
)}
{/* HAMBURGER DRAWER */}
      {showMenu && (
        <div onClick={() => setShowMenu(false)} style={{
          position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.45)', zIndex: 4000,
        }}>
          <div onClick={(e) => e.stopPropagation()} style={{
            position: 'absolute', top: 0, left: 0, bottom: 0, width: '82%', maxWidth: '340px',
            background: '#fafaf7', overflowY: 'auto', boxShadow: '4px 0 24px rgba(0,0,0,0.2)',
          }}>
            <div style={{
              display: 'flex', justifyContent: 'space-between', alignItems: 'center',
              padding: '20px 22px', borderBottom: '0.5px solid #eeeae3',
            }}>
              <span style={{
                fontFamily: '"Playfair Display", Georgia, serif', fontSize: '20px',
                letterSpacing: '5px', color: '#1a1a1a',
              }}>FIVETRY</span>
              <span onClick={() => setShowMenu(false)} style={{
                fontSize: '24px', cursor: 'pointer', color: '#1a1a1a', lineHeight: 1,
              }}>×</span>
            </div>

            <div style={{ padding: '22px' }}>
              <div style={{
                fontSize: '11px', letterSpacing: '2px', color: '#9c7d4f',
                fontWeight: '700', marginBottom: '14px',
              }}>SHOP NOW</div>
              {[
                { name: 'Western Wear', slug: 'western-wear' },
                { name: 'Ethnic Wear', slug: 'ethnic-wear' },
                { name: 'Formal Wear', slug: 'formal-wear' },
                { name: 'Co-ord Sets', slug: 'co-ord-sets' },
              ].map((cat) => (
                <div key={cat.name} onClick={() => { setShowMenu(false); navigate('/shop/' + cat.slug); }}
                  style={{ padding: '13px 0', fontSize: '16px', color: '#1a1a1a', cursor: 'pointer', borderBottom: '0.5px solid #eeeae3' }}>
                  {cat.name}
                </div>
              ))}
              <div onClick={() => { setShowMenu(false); navigate('/plus-sizes'); }}
                style={{ padding: '13px 0', fontSize: '16px', color: '#9c7d4f', fontWeight: '600', cursor: 'pointer', borderBottom: '0.5px solid #eeeae3' }}>
                Plus Sizes ★
              </div>

              <div style={{
                fontSize: '11px', letterSpacing: '2px', color: '#9c7d4f',
                fontWeight: '700', margin: '26px 0 14px',
              }}>COMING SOON</div>
              {['Footwear', 'Bags & Clutches', 'Belts', 'Sunglasses', 'Caps & Hats', 'Perfumes', 'Watches', 'Fashion Jewelry', 'Accessories'].map((c) => (
                <div key={c} onClick={() => setComingSoonItem(c)}
                  style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '13px 0', fontSize: '16px', color: '#999', cursor: 'pointer', borderBottom: '0.5px solid #eeeae3' }}>
                  {c}
                  <span style={{ fontSize: '9px', letterSpacing: '1px', color: '#b89968', border: '1px solid #d6cdb8', borderRadius: '4px', padding: '2px 6px' }}>SOON</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}

      {/* COMING SOON POPUP */}
      {comingSoonItem && (
        <div onClick={() => setComingSoonItem(null)} style={{
          position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.55)', zIndex: 5000,
          display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '24px',
        }}>
          <div onClick={(e) => e.stopPropagation()} style={{
            background: '#fafaf7', borderRadius: '18px', padding: '34px 28px', maxWidth: '340px',
            textAlign: 'center', boxShadow: '0 20px 60px rgba(0,0,0,0.3)',
          }}>
            <div style={{ fontSize: '40px', marginBottom: '14px' }}>✨</div>
            <div style={{ fontSize: '11px', letterSpacing: '3px', color: '#9c7d4f', fontWeight: '700', marginBottom: '10px' }}>COMING SOON</div>
            <h2 style={{ fontFamily: '"Playfair Display", Georgia, serif', fontSize: '24px', color: '#1a1a1a', margin: '0 0 12px' }}>{comingSoonItem}</h2>
            <p style={{ color: '#666', fontSize: '14px', lineHeight: '1.6', margin: '0 0 22px' }}>
              We're curating something special. We'll notify you the moment {comingSoonItem} goes live at FIVETRY.
            </p>
            <button onClick={() => setComingSoonItem(null)} style={{
              background: '#1a1a1a', color: 'white', border: 'none', padding: '13px 32px',
              borderRadius: '10px', fontSize: '13px', letterSpacing: '2px', fontWeight: '600', cursor: 'pointer',
            }}>GOT IT</button>
          </div>
        </div>
      )}

      {/* FOOTER */}
      <footer style={{
        background: '#1f4d3d',
        color: '#faf3ea',
        padding: '48px 24px 100px',
        borderTop: '2px solid #b89968',
      }}>
        <div style={{
          textAlign: 'center', marginBottom: '32px',
          maxWidth: '600px', marginLeft: 'auto', marginRight: 'auto',
        }}>
          <div style={{
            fontFamily: '"Playfair Display", Georgia, serif',
            fontSize: '26px', letterSpacing: '6px', color: '#faf3ea', marginBottom: '2px',
          }}>FIVETRY</div>
          <div style={{
            fontSize: '11px', letterSpacing: '3px', color: '#b89968', textTransform: 'uppercase',
            marginBottom: '18px',
          }}>Try before you buy</div>
          <div style={{
            fontSize: '10px', letterSpacing: '1px', color: '#b89968', fontWeight: '600',
            borderTop: '1px solid rgba(184,153,104,0.3)', paddingTop: '14px',
          }}>
            FREE TRIAL· NEXT-DAY DELIVERY· <br/> NO COMMITMENT· EASY RETURN.
          </div>
        </div>

        <div style={{
          display: 'grid',
          gridTemplateColumns: window.innerWidth < 600 ? '1fr 1fr' : 'repeat(3, 1fr)',
          gap: '28px', maxWidth: '700px', margin: '0 auto 32px',
        }}>
          <div>
            <div style={{ fontSize: '11px', letterSpacing: '2px', color: '#b89968', fontWeight: '700', marginBottom: '14px', textTransform: 'uppercase' }}>Shop</div>
            {[
              { name: 'Western Wear', slug: 'western-wear' },
              { name: 'Ethnic Wear', slug: 'ethnic-wear' },
              { name: 'Formal Wear', slug: 'formal-wear' },
              { name: 'Co-ord Sets', slug: 'co-ord-sets' },
            ].map((cat) => (
              <div key={cat.name} onClick={() => navigate('/shop/' + cat.slug)}
                style={{ fontSize: '13px', color: '#d8e5dd', marginBottom: '10px', cursor: 'pointer' }}>{cat.name}</div>
            ))}
            <div onClick={() => navigate('/plus-sizes')}
              style={{ fontSize: '13px', color: '#b89968', fontWeight: '600', cursor: 'pointer' }}>Plus Sizes ★</div>
          </div>

          <div>
            <div style={{ fontSize: '11px', letterSpacing: '2px', color: '#b89968', fontWeight: '700', marginBottom: '14px', textTransform: 'uppercase' }}>Reach Us</div>
            <a href="https://wa.me/918108885858" style={{ display: 'block', fontSize: '13px', color: '#d8e5dd', marginBottom: '12px', textDecoration: 'none', lineHeight: '1.5' }}>
                WhatsApp <br /> (message only)<br />8108885858
            </a>
            <a href="mailto:5ivetry@gmail.com" style={{ display: 'block', fontSize: '13px', color: '#d8e5dd', textDecoration: 'none' }}>
              5ivetry@gmail.com
            </a>
          </div>

          <div>
            <div style={{ fontSize: '11px', letterSpacing: '2px', color: '#b89968', fontWeight: '700', marginBottom: '14px', textTransform: 'uppercase' }}>Follow</div>
            <a href="https://instagram.com/fivetry_fashionandlifestyle" target="_blank" rel="noopener noreferrer"
              style={{ display: 'inline-flex', alignItems: 'center', gap: '8px', fontSize: '13px', color: '#d8e5dd', textDecoration: 'none' }}>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#b89968" strokeWidth="2">
                <rect x="2" y="2" width="20" height="20" rx="5" />
                <circle cx="12" cy="12" r="4" />
                <circle cx="17.5" cy="6.5" r="1" fill="#b89968" stroke="none" />
              </svg>
              Instagram
            </a>
          </div>
        </div>

        

        <div style={{
          display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: '10px 22px',
          maxWidth: '600px', margin: '0 auto 18px', paddingTop: '20px',
          borderTop: '1px solid rgba(184,153,104,0.3)',
        }}>
          {[
            { name: 'Privacy Policy', path: '/privacy' },
            { name: 'Terms & Conditions', path: '/terms' },
            { name: 'Return Policy', path: '/returns' },
            { name: 'Delivery Info', path: '/delivery' },
          ].map((l) => (
            <span key={l.path} onClick={() => navigate(l.path)}
              style={{ fontSize: '12px', color: '#d8e5dd', cursor: 'pointer', letterSpacing: '0.3px' }}>
              {l.name}
            </span>
          ))}
        </div>

        <div style={{ textAlign: 'center', fontSize: '11px', color: '#9bb3a6' }}>
          © 2026 FIVETRY Fashion &amp; Lifestyle
        </div>
      </footer>
</div>
  );
}
